/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Form, Input, Button, Checkbox, message } from "antd";
import {
  MailOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from "@ant-design/icons";
import axios from "axios";
import "./login.css";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";

const Login = () => {
  const [loading, setLoading] = React.useState(false);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const response = await axios.post(
        "https://cafemandhurah.mandurahcafe.com.au/api/login",
        {
          email: values.email,
          password: values.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
            // If you have a static auth token (rare for login), put it here. Otherwise, remove.
            // "Authorization": "Bearer YOUR_STATIC_TOKEN"
          },
        }
      );

      if (response?.data?.access_token) {
        localStorage.setItem("data", response.data);
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("Userdata", JSON.stringify(response.data.user));
        localStorage.setItem(
          "UserId",
          JSON.stringify(response?.data?.user?.id)
        );

        message.success("Login successful!");
        window.location.href = "/view-our-menu";
      } else {
        message.error("Login failed. Please try again.");
      }
    } catch (error) {
      message.error(error.response?.data?.message || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <img src="/Images/login-img.png" alt="Cafe Chat" loading="lazy"/>
      </div>

      <div className="login-right">
        <h2 className="login-heading">LOG IN</h2>
        <Form layout="vertical" onFinish={onFinish} className="login-form">
          <Form.Item
            name="email"
            label="Email Id"
            rules={[{ required: true, message: "Please input your email!" }]}
          >
            <Input
              placeholder="johndoe@gmail.com"
              prefix={<MailOutlined />}
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password
              placeholder="Password@123"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              size="large"
            />
          </Form.Item>

          <div className="login-options">
            <Checkbox>Remember Me</Checkbox>
            <a href="#" className="forgot-link">
              Forgot Password?
            </a>
          </div>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-btn"
              loading={loading}
            >
              LOG IN
            </Button>
          </Form.Item>
        </Form>

        <div className="or-btn">
          <img src="./Images/login-or.png" alt="login" loading="lazy"/>
        </div>

        <div className="google-btn">
          <GoogleLogin
            onSuccess={async (credentialResponse) => {
              try {
                const decoded = jwtDecode(credentialResponse.credential);
                const response = await axios.post(
                  "https://cafemandhurah.mandurahcafe.com.au/api/login",
                  {
                    email: decoded.email,
                    name: decoded.name,
                    social_login_provider: "google",
                    // token: credentialResponse.credential,
                  },
                  {
                    headers: {
                      "Content-Type": "application/json",
                    },
                  }
                );

                if (response?.data?.access_token) {
                  localStorage.setItem("token", response.data.access_token);
                  message.success("Google login successful!");
                  window.location.href = "/view-our-menu";
                  localStorage.setItem(
                    "Userdata",
                    JSON.stringify(response.data.user)
                  );
                  localStorage.setItem(
                    "UserId",
                    JSON.stringify(response?.data?.user?.id)
                  );
                } else {
                  message.error("Google login failed.");
                }
              } catch (err) {
                console.error(err);
                message.error("Google login error.");
              }
            }}
            onError={() => {
              message.error("Google Sign In was unsuccessful.");
            }}
          />
        </div>

        <p className="register-link">
          Don't have an account? <a href="/register">Create Account</a>
        </p>
      </div>
    </div>
  );
};

export default Login;
